module.exports = "<h3>Logging you out ...</h3>\r\n"